export const DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_PREFIX = "features.topics.components.data_summary_with_errors_modal";

export const DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_KEYS = {
  modal_title:                                     "modal_title",
  select_another_file_button_text:                 "select_another_file_button_text",
  remove_rows_with_errors_and_proceed_button_text: "remove_rows_with_errors_and_proceed_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/DataSummaryWithErrorsModali18nConstants.js